import { render } from "./ApAging.vue?vue&type=template&id=368d8118&scoped=true"
import script from "./ApAging.vue?vue&type=script&lang=js"
export * from "./ApAging.vue?vue&type=script&lang=js"

import "./ApAging.vue?vue&type=style&index=0&id=368d8118&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368d8118"]])

export default __exports__